exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NIvYfuzi_bX5JgnSvj_X{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.RPaW-H9-JNnDtmirRrTnZ{font-size:12px;color:#a80000}html[dir] .RPaW-H9-JNnDtmirRrTnZ{background-color:#fde7e9;margin-top:8px;padding:8px 9px;border-radius:2px}._2tOcH43KN2o9WfVm_nMXvc{color:#a80000;position:relative;top:2px}html[dir=ltr] ._2tOcH43KN2o9WfVm_nMXvc{padding-right:4px}html[dir=rtl] ._2tOcH43KN2o9WfVm_nMXvc{padding-left:4px}", ""]);
// Exports
exports.locals = {
	"assetErrorNotFound": "NIvYfuzi_bX5JgnSvj_X",
	"text": "RPaW-H9-JNnDtmirRrTnZ",
	"icon": "_2tOcH43KN2o9WfVm_nMXvc"
};